module.exports = "<backup-plan-page></backup-plan-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/backup.html
// module id = 1649
// module chunks = 0